export const useGlobalStore = defineStore('global', () => {
    const mapRtlPluginLoaded = ref<boolean>(false)

    return {
        mapRtlPluginLoaded,
    }
})
